<template>
    <v-dialog v-model="shows" width="240">
        <template #activator="{ attrs, on }">
            <slot v-bind="{ attrs, on }" />
        </template>
        <v-card>
            <v-card-title>
                액셀 다운로드
                <v-spacer />
                <v-icon @click="exit">mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text class="py-4">
                <v-row class="ma-n2">
                    <v-col class="pa-2" cols="12">
                        <v-text-field v-model="form.skip" label="skip" type="number" placeholder=" " clearable hide-details dense outlined autofocus @click:clear="sync" @input="sync" @keydown.enter="$refs['limit'].focus()" />
                    </v-col>
                    <v-col class="pa-2" cols="12">
                        <v-text-field v-model="form.limit" label="limit" type="number" placeholder=" " clearable hide-details dense outlined @click:clear="sync" @input="sync" @keydown.enter="emit" ref="limit" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn text color="primary" @click="emit">다운로드</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
let initForm = (form = {}) => ({
    ...(form || {}),
    skip: +(form?.skip || 0),
    limit: +(form?.limit || 0),
});
export default {
    data: () => ({
        shows: false,

        form: initForm(),
    }),
    methods: {
        init() {
            this.form = initForm();
        },
        exit() {
            this.shows = false;
        },
        sync() {
            this.$nextTick(() => (this.form = initForm(this.form)));
        },
        emit() {
            this.$emit("excel", this.form);
            this.shows = false;
        },
    },
    watch: {
        shows(shows) {
            if (shows) this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style></style>
